// Shared urgency bands for a countdown to an expiry date.
//
// Extracted from TrialBanner so the sidebar countdown and the Plan tab cannot
// drift apart: two surfaces describing the same date must not disagree about
// whether it is urgent. The thresholds (7 days, 3 days) are the product rule,
// not a styling detail, which is why they live here rather than being inlined
// at each call site.
export const EXPIRY_URGENT_DAYS = 3;
export const EXPIRY_SOON_DAYS = 7;

const TONES = Object.freeze({
  urgent: { bg: 'bg-red-50', border: 'border-red-200', text: 'text-red-800', icon: 'text-red-600' },
  soon: {
    bg: 'bg-orange-50',
    border: 'border-orange-200',
    text: 'text-orange-800',
    icon: 'text-orange-600',
  },
  normal: {
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    text: 'text-blue-800',
    icon: 'text-blue-600',
  },
});

/**
 * Tone for a countdown. A null/undefined day count is a permanent plan, which
 * is never urgent.
 *
 * @param {number | null | undefined} daysRemaining
 */
export function expiryTone(daysRemaining) {
  if (daysRemaining == null) return TONES.normal;
  if (daysRemaining <= EXPIRY_URGENT_DAYS) return TONES.urgent;
  if (daysRemaining <= EXPIRY_SOON_DAYS) return TONES.soon;
  return TONES.normal;
}

export const EXPIRED_TONE = TONES.urgent;
